<template>
    <div class="plan-extra-hours-panel">
        <div class="plan-extra-hours-left-title">Extra Hours</div>
        <div class="plan-extra-hours-left-price">
            <StripePrice :price="hourPrice * count" />
        </div>
        <div class="plan-extra-hours-left-line"></div>
        <FFadeTransitionOutIn>
            <div class="plan-extra-hours-left-counter" v-if="countEditable && !disabled">
                <div class="counter-button" :class="{ disabled: count <= 1 }"
                    @click="count > 1 && $emit('update:count', count - 1)">
                    <f-icon icon="fa6-minus"></f-icon>
                </div>
                <div class="counter-count">{{ count }}</div>
                <div class="counter-button" @click="$emit('update:count', count + 1)">
                    <f-icon icon="fa6-plus"></f-icon>
                </div>
            </div>
            <div class="plan-extra-hours-left-counter readonly" v-else>
                <div class="counter-count">{{ count }}</div>
            </div>
        </FFadeTransitionOutIn>
        <div class="plan-extra-hours-left-info">
            <div><svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M14.25 9.5C14.25 12.3995 11.8995 14.75 9 14.75C6.10051 14.75 3.75 12.3995 3.75 9.5C3.75 6.60051 6.10051 4.25 9 4.25C11.8995 4.25 14.25 6.60051 14.25 9.5ZM15.75 9.5C15.75 13.2279 12.7279 16.25 9 16.25C5.27208 16.25 2.25 13.2279 2.25 9.5C2.25 5.77208 5.27208 2.75 9 2.75C12.7279 2.75 15.75 5.77208 15.75 9.5ZM9.75 7.25C9.75 7.66421 9.41421 8 9 8C8.58579 8 8.25 7.66421 8.25 7.25C8.25 6.83579 8.58579 6.5 9 6.5C9.41421 6.5 9.75 6.83579 9.75 7.25ZM9.75 12.5C9.75 12.9142 9.41421 13.25 9 13.25C8.58579 13.25 8.25 12.9142 8.25 12.5V9.5C8.25 9.08579 8.58579 8.75 9 8.75C9.41421 8.75 9.75 9.08579 9.75 9.5V12.5Z"
                        fill="#2AD5D5" />
                </svg></div>
            <div>
                Additional hours can be used for the entire duration of the plan
            </div>
        </div>
    </div>
</template>
<script>

import StripePrice from "/vodalys2023/stripe/main/components/StripePrice.vue";


export default {
    components: {
        StripePrice
    },
    props: {
        disabled: Boolean,
        component: Object,
        count: Number | String,
        hourPrice: Number,
        countEditable: {
            type: Boolean,
            default: false
        }
    }

}</script>

<style lang="scss">
.plan-extra-hours-panel {

    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: var(--black);
    border-radius: 8px;
    box-shadow: 0 4px 16px #1616151a;
    padding: 32px 32px 48px 32px;
    flex: 1 1 auto;

    .plan-extra-hours-left-title {
        color: var(--primary);
        text-align: center;
        font-family: Lato;
        font-size: 36px;
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
        /* 36px */
    }

    .plan-extra-hours-left-price {
        color: var(--white);
        text-align: center;
        // font-family: Lato;
        font-size: 60px;
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
        /* 60px */
    }

    .plan-extra-hours-left-info {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        flex-basis: 100%;
        max-width: calc(300px - 2 * 32px);

    }

    .plan-extra-hours-left-line {
        margin: 0 16px;
        height: 2px;
        background-color: #373838;
    }

    .plan-extra-hours-left-counter {
        display: flex;
        gap: 4px;
        align-items: center;
        border-radius: 24px;
        background-color: var(--white-a10);
        align-self: center;
        padding: 4px;

        .counter-button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            border-radius: 32px;
            color: var(--navigation);
            font-size: 24px;
            cursor: pointer;

            &:hover {
                background: var(--navigation-a25);
            }

            &.disabled {
                opacity: 0.5;
                cursor: default;

                &:hover {
                    background: none;
                }
            }
        }

        .counter-count {
            color: var(--black);
            font-weight: 800;
            display: flex;
            width: 32px;
            height: 32px;
            padding: 8px;
            justify-content: center;
            align-items: center;
            border-radius: 32px;
            background: var(--primary);
        }

        &.readonly {

            background-color: transparent;

            .counter-count {
                border-radius: 32px;
                background: var(--white-a25);
                color: var(--white)
            }
        }
    }

}
</style>